import * as React from 'react';
import { useParams } from 'react-router-dom';
import { CompletedReleaseSummary } from '../../types';
import { AppComponentProps, AppRouteComponentMatchParams } from '../../typescriptHelpers';
import { TargetDatesWidget } from '@/components/appHome/widgets/TargetDatesWidget';
import { AppHomeCard } from '@/components/appHome/AppHomeCard';
import Tag from 'antd/lib/tag';
import { antGrey, titleStyle } from '@/components/styles/globalStyles';
import { Divider, Space } from 'antd/lib';
import { ReleaseSummaryWidget } from '@/components/appHome/widgets/ReleaseSummaryWidget';
import { statusStringForReleaseStatus } from '@/helpers/displayHelpers';
import { statusColorForReleaseStatus } from '@/helpers';

interface SkippedReleaseSummaryProps extends AppComponentProps {
    summary: CompletedReleaseSummary;
}

export const SkippedReleaseComponent: React.FC<SkippedReleaseSummaryProps> = (props) => {
    const { orgIdParam, appIdParam } = useParams<AppRouteComponentMatchParams>();

    return (
        <AppHomeCard
            appId={appIdParam}
            orgId={orgIdParam}
            releaseId={props.summary.releaseId}
            id={props.summary.id}
            displayableVersion={props.summary.displayableVersion}
            releaseName={props.summary.releaseName}
            headerComponent={
                <>
                    <Space
                        align="center"
                        split={<Divider type="vertical" style={{ minHeight: 26, backgroundColor: antGrey.grey5 }} />}
                        wrap
                    >
                        <Tag
                            style={{
                                ...titleStyle,
                                fontSize: 11,
                                lineHeight: '22px',
                                color: 'white',
                            }}
                            color={statusColorForReleaseStatus(props.summary.status)}
                        >
                            {statusStringForReleaseStatus(props.summary.status)}
                        </Tag>
                    </Space>
                </>
            }
            contentComponent={
                <>
                    <ReleaseSummaryWidget summaryMessage={props.summary.releaseSummaryMessage} />
                </>
            }
            sideComponent={
                <>
                    <TargetDatesWidget appId={appIdParam} summary={props.summary} />
                </>
            }
        />
    );
};
